import { ErrorMessageEntities } from "@/domain/entities/MainApp";
import {
  CLIENT_ERROR,
  INTERNAL_SERVER_ERROR,
  INTERNET_ERROR,
  parsingErrorResponse
} from "./Utils";

interface ErrorConfig {
  error: any;
  defaultTitle?: string;
  defaultMessage?: string;
  defaultImage?: string;
}

export const handleCommonErrors = ({
  error,
  defaultTitle = "Terjadi gangguan sistem",
  defaultMessage = 'Klik "Muat ulang" atau coba beberapa saat lagi.',
  defaultImage = "error-token-ngen"
}: ErrorConfig): ErrorMessageEntities => {
  const errorData = parsingErrorResponse(error);

  if (
    errorData.type === INTERNAL_SERVER_ERROR ||
    errorData.type === CLIENT_ERROR
  ) {
    errorData.image = defaultImage;
    errorData.title = defaultTitle;
    errorData.message = defaultMessage;
  } else if (errorData.type === INTERNET_ERROR) {
    errorData.title = "Jaringan internet terputus";
    errorData.message =
      'Periksa jaringan internal Anda lalu klik "Muat ulang".';
  }

  return errorData;
};
